import ui from '@/components/ui.module.css';
import { CtaBand, HeroLead, PageHero } from '@/components/ui';
import { BEYOND_ECOMMERCE, SERVICES_DETAIL } from '@/content/services';
import styles from './Services.module.css';

export function Services() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Engineering for commerce, and the systems around it."
        lead={
          <HeroLead>
            We work across the full lifecycle - architecture, build, integration and long-term
            maintenance. Most engagements start with a conversation about the business problem
            rather than a technology choice.
          </HeroLead>
        }
      />

      <section className={styles.section} aria-labelledby="ecommerce-heading">
        <div className={styles.head}>
          <h2 id="ecommerce-heading" className={styles.headTitle}>
            eCommerce
          </h2>
          <span className={styles.badge}>Primary specialisation</span>
        </div>

        <div className={styles.cardGrid}>
          {SERVICES_DETAIL.map((service) => (
            <article className={styles.card} key={service.title}>
              <h3 className={styles.cardTitle}>{service.title}</h3>
              <p className={styles.cardText}>{service.description}</p>
              <ul className={ui.tagRow}>
                {service.tags.map((tag) => (
                  <li className={ui.tag} key={tag}>
                    {tag}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className={styles.sectionRuled} aria-labelledby="beyond-heading">
        <div className={styles.ruled}>
          <p className={ui.label} style={{ marginBottom: 20 }}>
            Beyond eCommerce
          </p>
          <div className={styles.beyondHead}>
            <h2 id="beyond-heading" className={styles.beyondTitle}>
              Software that has nothing to do with a shopping cart.
            </h2>
            <p className={styles.beyondText}>
              Our team&apos;s experience is broader than commerce. Where a problem is well defined
              and the engineering is the difficult part, we are comfortable taking it on - including
              work that looks nothing like a storefront.
            </p>
          </div>
          <ul className={styles.beyondGrid}>
            {BEYOND_ECOMMERCE.map((item) => (
              <li className={styles.beyondItem} key={item.title}>
                <h3 className={styles.beyondItemTitle}>{item.title}</h3>
                <p className={styles.beyondItemText}>{item.description}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <CtaBand
        title="Not sure which of these you need?"
        text="Describe the situation and we will tell you what we would do about it."
      />
    </>
  );
}
